// Generated file - do not change manually!
/**
 * Different types of BusyIndicator.
 */
export var BusyIndicatorSize;
(function (BusyIndicatorSize) {
    /**
     * large size
     */
    BusyIndicatorSize["Large"] = "Large";
    /**
     * medium size
     */
    BusyIndicatorSize["Medium"] = "Medium";
    /**
     * small size
     */
    BusyIndicatorSize["Small"] = "Small";
})(BusyIndicatorSize || (BusyIndicatorSize = {}));
